import React, { useEffect, useState } from "react"
import { Alert, Button } from "react-bootstrap"

const AppBanner = () => {
  const [showBanner, setShowBanner] = useState(false)
  const [platform, setPlatform] = useState(null)

  useEffect(() => {
    // Verificar si ya se cerró el banner en esta sesión
    const bannerDismissed = sessionStorage.getItem("appBannerDismissed")
    if (bannerDismissed) {
      return
    }

    // Detectar si es un dispositivo móvil
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    
    if (!isMobile) {
      return
    }

    // Detectar plataforma
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
    const isAndroid = /Android/i.test(navigator.userAgent)

    if (isIOS) {
      setPlatform("ios")
      setShowBanner(true)
    } else if (isAndroid) {
      setPlatform("android")
      setShowBanner(true)
    }
  }, [])

  const handleOpenApp = () => {
    const deepLink = "ceaemociones://"
    
    // Intentar abrir la app
    window.location.href = deepLink

    // Si la app no se abre en 2.5 segundos, mostrar mensaje
    setTimeout(() => {
      if (document.hidden) {
        // La app se abrió (el usuario salió de la página)
        return
      }
      
      // La app no está instalada, mostrar mensaje
      if (platform === "ios") {
        alert("La aplicación CEAEmociones no está instalada en este dispositivo. Por favor, instala la app para continuar.")
      } else if (platform === "android") {
        alert("La aplicación CEAEmociones no está instalada en este dispositivo. Por favor, instala el archivo APK para continuar.")
      }
    }, 2500)
  }

  const handleDismiss = () => {
    setShowBanner(false)
    sessionStorage.setItem("appBannerDismissed", "true")
  }

  if (!showBanner) {
    return null
  }

  return (
    <Alert
      variant="primary"
      dismissible
      onClose={handleDismiss}
      className="app-banner mb-0"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        borderRadius: 0,
        margin: 0,
      }}
    >
      <div className="d-flex align-items-center justify-content-between">
        <div>
          <strong>CEAEmociones</strong>
          <p className="mb-0 small">¿Tienes la app instalada? Ábrela para una mejor experiencia</p>
        </div>
        <Button variant="light" size="sm" onClick={handleOpenApp} className="ms-2">
          Abrir App
        </Button>
      </div>
    </Alert>
  )
}

export default AppBanner
